import { Link } from 'react-router-dom'
import {Droplets, Mail} from 'lucide-react'
import { COMPANY, NAV_LINKS } from '@/lib/constants'

export default function Footer() {
  return (
    <footer className="bg-[#1C1C1C] text-white" role="contentinfo">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Droplets className="w-5 h-5 text-[#1A6B4E]" />
              <span className="text-lg font-semibold font-['Outfit'] tracking-tight">
                {COMPANY.name}
              </span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Modern water filtration designed for European households who want cleaner, safer drinking water.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-5">Navigation</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/60 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-5">Contact</h4>
            <a
              href={`mailto:${COMPANY.email}`}
              className="flex items-center gap-2.5 text-white/60 hover:text-white transition-colors text-sm"
            >
              <Mail className="w-4 h-4 text-[#1A6B4E]" />
              {COMPANY.email}
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/8">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <div className="flex gap-5">
            {['Privacy Policy', 'Terms of Service'].map((item) => (
              <a key={item} href="#" className="text-white/30 hover:text-white/60 text-xs transition-colors">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
